import React, { useEffect, useState } from 'react';

const API = 'https://v-room.app/api';

const CATEGORY_LABELS = {
  news: 'AKTUALNOŚCI',
  update: 'AKTUALIZACJA',
  beta: 'BETA',
  event: 'EVENT',
};

function timeAgo(dateStr) {
  const diff = Math.floor((Date.now() - new Date(dateStr)) / 1000);
  if (diff < 60) return 'przed chwilą';
  if (diff < 3600) return `${Math.floor(diff / 60)} min. temu`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} godz. temu`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)} dni temu`;
  return new Date(dateStr).toLocaleDateString('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' });
}

function AnnouncementModal({ item, onClose }) {
  const catLabel = CATEGORY_LABELS[item.category] ?? CATEGORY_LABELS.news;

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div className="ann-modal-overlay" onClick={onClose}>
      <div className="ann-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="ann-modal-close" onClick={onClose}>
          <span className="material-icons">close</span>
        </button>
        {item.coverImage && (
          <img src={item.coverImage} alt={item.title} className="ann-modal-cover" />
        )}
        <div className="ann-modal-body">
          <div className="ann-modal-meta">
            <span className="ann-cat-badge">{catLabel}</span>
            {item.pinned && <span className="ann-pinned-badge">PRZYPIĘTE</span>}
            <span className="ann-modal-date">{timeAgo(item.createdAt)}</span>
          </div>
          <h2 className="ann-modal-title">{item.title}</h2>
          <div className="ann-modal-content">
            {item.content.split('\n').map((line, i) =>
              line.trim() === '' ? <br key={i} /> : <p key={i}>{line}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function AnnouncementCard({ item, onClick }) {
  const catLabel = CATEGORY_LABELS[item.category] ?? CATEGORY_LABELS.news;
  const excerpt = item.excerpt || `${item.content.slice(0, 100)}${item.content.length > 100 ? '...' : ''}`;

  return (
    <article
      className={`ann-feed-card ${item.pinned ? 'ann-feed-card-pinned' : ''}`}
      onClick={() => onClick(item)}
      onKeyDown={(e) => e.key === 'Enter' && onClick(item)}
      role="button"
      tabIndex={0}
    >
      {item.coverImage ? (
        <div className="ann-feed-img-wrap">
          <img src={item.coverImage} alt="" className="ann-feed-img" />
          <div className="ann-feed-img-overlay" />
        </div>
      ) : (
        <div className="ann-feed-img-wrap ann-feed-img-placeholder">
          <span className="material-icons">article</span>
        </div>
      )}
      <div className="ann-feed-body">
        <div className="ann-feed-meta">
          <span className="ann-cat-badge">{catLabel}</span>
          <span className="ann-feed-date">{timeAgo(item.createdAt)}</span>
        </div>
        <h3 className="ann-feed-title">{item.title}</h3>
        <p className="ann-feed-excerpt">{excerpt}</p>
      </div>
    </article>
  );
}

export default function AnnouncementsSection() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetch(`${API}/announcements`)
      .then((r) => r.json())
      .then((data) => { setItems(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const categories = ['all', ...new Set(items.map((i) => i.category))];
  const filtered = filter === 'all' ? items : items.filter((i) => i.category === filter);

  return (
    <section id="news" className="ann-section">
      <div className="section-title">
        <h2>
          TELEMETRY <span>FEED</span>
        </h2>
        <p>Ekskluzywny magazyn — bądź na bieżąco z rozwojem VROOM</p>
      </div>

      {categories.length > 2 && (
        <div className="ann-filters">
          {categories.map((c) => (
            <button
              key={c}
              type="button"
              className={`ann-filter-btn ${filter === c ? 'active' : ''}`}
              onClick={() => setFilter(c)}
            >
              {c === 'all' ? 'WSZYSTKIE' : (CATEGORY_LABELS[c] ?? c.toUpperCase())}
            </button>
          ))}
        </div>
      )}

      {loading ? (
        <div className="ann-loading">
          <div className="profile-spinner" />
        </div>
      ) : filtered.length === 0 ? (
        <div className="ann-empty">
          <span className="material-icons">article</span>
          <p>Brak aktualności</p>
        </div>
      ) : (
        <div className="ann-slider-wrap">
          <div className="ann-slider">
            {filtered.map((item) => (
              <AnnouncementCard key={item.id} item={item} onClick={setSelected} />
            ))}
          </div>
        </div>
      )}

      {selected && (
        <AnnouncementModal item={selected} onClose={() => setSelected(null)} />
      )}
    </section>
  );
}
